import { EditTenantRequest } from 'src/features/tenants/api/tenantApiTypes';
import { TenantFormData } from 'src/features/tenants/types/tenantForm.types';

export function editTenantRequestFactory(
  formData: TenantFormData
): EditTenantRequest {
  const { initialData, settings, domains } = formData;
  return {
    initialData: {
      ...initialData,
      document: initialData.document.replace(/\D/g, ''),
    },
    settings: {
      add: settings?.add
        ? settings.add.map(setting => ({
            configKeyContext: String(setting.configKeyContext),
            configKeyDescription: setting.configKeyDescription ?? undefined,
            configKey: String(setting.configKey),
            configValue: String(setting.configValue),
            encrypted: setting.encrypted === 'true',
            public: setting.public === 'true',
          }))
        : [],
      edit: settings?.edit
        ? settings.edit.map(setting => ({
            id: Number(setting.id),
            configKeyContext: String(setting.configKeyContext),
            configKeyDescription: setting.configKeyDescription ?? undefined,
            configKey: String(setting.configKey),
            configValue: String(setting.configValue),
            encrypted: setting.encrypted === 'true',
            public: setting.public === 'true',
          }))
        : [],
      delete: settings?.delete ?? [],
    },
    domains: {
      add: domains?.add
        ? domains.add.map(domain => ({
            domain: String(domain.domain),
            isPrimary: domain.isPrimary,
          }))
        : [],
      edit: domains?.edit
        ? domains.edit.map(domain => ({
            id: Number(domain.id),
            domain: String(domain.domain),
            isPrimary: domain.isPrimary,
          }))
        : [],
      delete: domains?.delete ?? [],
    },
  };
}
